import React, { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

function InternalUserLogin({ children }) {

  const { instance, accounts, inProgress } = useMsal();

  // Prevent duplicate redirects, especially with React StrictMode
  const loginStarted = useRef(false);

  useEffect(() => {

    // User is already authenticated
    if (accounts.length > 0) {
      return;
    }

    // MSAL is currently processing something
    if (inProgress !== "none") {
      return;
    }

    // Prevent starting login more than once
    if (loginStarted.current) {
      return;
    }

    loginStarted.current = true;

    instance.loginRedirect(loginRequest)
      .catch((error) => {
        console.error(
          "Entra authentication error:",
          error
        );

        // Allow another attempt if redirect failed
        loginStarted.current = false;
      });

  }, [instance, accounts, inProgress]);


  // Authentication completed
  if (accounts.length > 0) {
    return children;
  }


  // Show something while redirecting
  return (
    <div
      className="authentication-loading"
      role="status"
      aria-live="polite"
    >
      <div className="authentication-spinner" />

      <div className="authentication-title">
        Authenticating...
      </div>

      <div className="authentication-message">
        Please wait while we verify your access.
      </div>
    </div>
  );
}

export default InternalUserLogin;